export const FAQ = [
  {
    keywords: ['about', 'what is', 'tell me about', 'company', 'website'],
    response: "ingreBOARD is a tool that helps you understand what's in your food and cosmetic products. We analyze ingredient lists to provide detailed information about each component. Would you like to learn more about our features or visit our About page?"
  },
  {
    keywords: ['how to use', 'how does it work', 'instructions', 'guide', 'help'],
    response: "Using ingreBOARD is simple! Just navigate to our Scanner page, upload a photo of an ingredient list, and we'll analyze it for you. Would you like me to show you how to get started?"
  },
  {
    keywords: ['contact', 'email', 'reach', 'support'],
    response: "You can reach us at aryan@techynar.com for any questions or support needs. We aim to respond to all inquiries within 24 hours."
  },
  {
    keywords: ['team', 'who made', 'developers', 'created'],
    response: "ingreBOARD is a tool developed to help users understand ingredients in their products. For more information, visit our About page."
  },
  {
    keywords: ['features', 'what can', 'capabilities', 'do'],
    response: "ingreBOARD offers several key features:\n- Ingredient Analysis\n- Allergen Detection\n- Nutritional Information Extraction\n- Smart Text Processing\nWhich feature would you like to know more about?"
  },
  {
    keywords: ['allergen', 'allergy', 'allergies'],
    response: "Our allergen detection system identifies common allergens in ingredient lists, including nuts, dairy, soy, wheat, eggs, and more. Would you like to try it out with your product?"
  },
  {
    keywords: ['safe', 'safety', 'dangerous', 'harmful'],
    response: "We analyze ingredients and categorize them based on safety levels: safe, caution, or warning. Each ingredient comes with detailed information about potential concerns or benefits."
  },
  {
    keywords: ['scan', 'upload', 'photo', 'picture', 'image'],
    response: "To scan a product, visit our Scanner page and either upload an image or take a photo of the ingredient list. Our system will analyze it and provide detailed information about each ingredient."
  },
  {
    keywords: ['free', 'cost', 'price', 'paid'],
    response: "ingreBOARD is currently free to use! Simply visit our website and start analyzing ingredients right away."
  },
  {
    keywords: ['privacy', 'data', 'security'],
    response: "We take privacy seriously. The images you upload are processed securely and are not stored permanently. We don't collect any personal information unless explicitly provided."
  }
];